import {
  type IAccountSignInTimes,
  isNewAccountSignIn,
} from "~/utils/isNewAccountSignIn";

export const isExistingAccountSignIn = (
  account: IAccountSignInTimes
): boolean =>
  Boolean(account.createdAt && account.lastSignInAt) &&
  !isNewAccountSignIn(account);
